import { appSyncApolloClient, accountsGet } from '../helpers/api';
import gql from 'graphql-tag';

export async function getPermissions(orgId, userId) {
  if (!orgId) return null;
  if (!userId) return null;

  const resp = await appSyncApolloClient.query({
    fetchPolicy: 'no-cache',
    variables: {
      orgId: `org-${orgId}`,
      userId: `user-${userId}`,
    },
    query: gql`
      query getOrgUser($orgId: String!, $userId: String!) {
        user: getOrgUser(orgId: $orgId, userId: $userId) {
          deniedPermissions
          allowedPermissions
          permissions
        }
      }
    `,
  });
  return resp?.data?.user;
}

function isGracePeriod(location) {
  if (!location.soldDate) return false;
  let soldDate;
  if (!Number.isNaN(+location.soldDate)) {
    soldDate = new Date(+location.soldDate);
  } else {
    soldDate = new Date(location.soldDate);
  }
  const gracePeriodEnd = new Date(soldDate);
  gracePeriodEnd.setDate(gracePeriodEnd.getDate() + 7);
  return gracePeriodEnd > new Date();
}

function sanatizeLocations(locations) {
  return locations.map(loc => {
    let name = loc.name;
    const value = loc.locationId.replace('loc-', '');
    let nameValue = loc.name === value ? loc.name : `${loc.name} (${value})`;
    const isSold = loc.soldDate;
    const isClosed = loc.locationStatus === 'PERMANENTLY_CLOSED';
    if (isSold) {
      name = `${name} (Sold)`;
      nameValue = `${nameValue} (Sold)`;
    }
    if (isClosed) {
      name = `${name} (Closed)`;
      nameValue = `${nameValue} (Closed)`;
    }
    const isActive = !isSold && !isClosed;
    return {
      ...loc,
      name,
      value,
      nameValue,
      isActive,
    };
  }).filter((loc) => loc.isActive || (isGracePeriod(loc) || loc.willKeepHistoricalData))
}

export async function getUserLocations({ orgId, userId }) {
  try {
    const params = new URLSearchParams({
      selectedFields: ['locationId', 'locationStatus', 'name', 'willKeepHistoricalData', 'soldDate'],
      paginate: false,
    });
    const url = `accounts/organizations/${orgId}/users/${userId}/locations?${params.toString()}`;
    const resp = await accountsGet(url);
    return sanatizeLocations(resp.data);
  } catch (error) {
    throw new Error(`Error getting org user locations: ${error}`);
  }
}
